<template>
    <!--My orders content-->
    <div class="myskov-orders">
        <div class="myskov-orders__header">
            <h2 v-text="translations.title"></h2>
            <p v-html="translations.description"></p>
        </div>
        <msg-block type="warning" v-if="!loadingOrders && !orders.length">
            <p><b v-text="translations.no_orders_title"></b></p>
            <p v-html="translations.no_orders_message"></p>
            <router-link to="/" v-text="translations.start_search_txt"></router-link>
        </msg-block>
        <msg-block v-if="loadingOrders">
            <p><b v-text="translations.loading"></b></p>
        </msg-block>
        <msg-block v-if="loadingOrdersErr" type="error">
            <p><b v-text="loadingOrdersErr"></b></p>
        </msg-block>
        <order v-for="(order, orderKey) in orders" :order="order" :key="orderKey"></order>
    </div>
</template>

<script>
import SkovApi from '../../skovapi.js';
import Order from './../order.vue';
import MsgBlock from './../msg-block.vue';
export default {
    data() {
        return {
            orders: [ ],
            loadingOrders: false,
            loadingOrdersErr: null,
            translations: APP_CONFIG.TRANSLATION.MYSKOV_ORDERS
        }
    },
    mounted() {
        this.loadOrders();
    },
    methods: {
        loadOrders() {
            if(this.loadingOrders)
                return;

            this.loadingOrders = true;
            SkovApi.getBookings().then((res) => {
                this.orders = res.data;
                this.loadingOrders = false;
            }).catch((error) => {
                console.error(error);
                this.loadingOrdersErr = this.translations.ERRORS.fetching_orders
                this.loadingOrders = false;
            })
        }
    },
    components: {
        Order,
        MsgBlock
    }
}
</script>
